import React from 'react';

class FilteredPackagesSwitch extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    modeFilter = [
        {
            name: '综合排序',
            key: 'all'
        },
        {
            name: '最新',
            key: 'latest'
        },
        {
            name: '最热',
            key: 'hot'
        }
    ]

    onClick = value => this.props.onChange(value)

    render() {
        const { showMode, filterMode } = this.props

        return (
            <div className='filtered-packages-switch-container'>
                <div className='filter-mode'>
                    {
                        this.modeFilter.map(filter => {
                            const isActive = filter.key === filterMode
                            return <span
                                onClick={() => this.onClick({filterMode: filter.key})}
                                className={isActive ? 'active' : ''}
                            >
                                {filter.name}
                            </span>
                        })
                    }
                </div>
                <div className='show-mode'>
                    {
                        ['list', 'grid'].map(filter => {
                            const isActive = filter === showMode
                            return <span
                                onClick={() => this.onClick({showMode: filter})}
                                className={`${filter} ${isActive ? filter + '-red' : filter + '-gray'}`}
                            />
                        })
                    }
                </div>
            </div>
        );
    }
}

export default FilteredPackagesSwitch;
